import {AxiosResponse} from 'axios';
import {History} from 'history';

import {CATEGORIES, CATEGORY_LENSES_ID} from 'constants/category';
import {parseUrl} from './parseUrl';
import {SearchResultDataType} from '../types';

type PageStateType =
    | {
          page: string;
          params: {[key: string]: unknown};
      }
    | undefined;

/**
 * getPageStateParamsByUrl
 * @returns {PageStateType} - page state params by url
 */
export const getPageStateParamsByUrl = ({
    pathname,
    search,
}: {
    pathname: string;
    search: string;
}): PageStateType => {
    const category = `${pathname}${search}`.replace('/', '');
    const id: number | undefined = CATEGORIES[category];

    return {
        page: 'category',
        params: {id, isContacts: id === CATEGORY_LENSES_ID},
    };
};

/**
 * Handles fetched search request and moves a customer to search/campaign/product page according to received search results
 * @param {void} redirect - history push function
 * @param {string} keyword - search word
 * @param {AxiosResponse} response - received search response
 */
export const handleSearchResponse = (
    redirect: History['push'],
    keyword: string,
    {data}: AxiosResponse<SearchResultDataType>,
) => {
    if ('redirectUrl' in data) {
        const {pathname, search} = parseUrl(data.redirectUrl);

        redirect(`${pathname}${search}`);
    } else if (data.items && data.total === 1) {
        redirect(`/${data.items[0].children?.[0].url}`, {
            page: 'product',
            params: {id: data.items[0].children?.[0].id},
        });
    } else {
        redirect(`/salesperson/result?q=${encodeURI(keyword)}`);
    }
};
